import { getPersonSchema } from "@/services/api";

export const generalInfoTabSchema = getPersonSchema().pick([
  "websites",
  "phones",
  "emails",
  "socialNetworks",
  "addresses",
  "anniversaries",
]);
